import React from 'react';

import { Snapshot as SnapshotContent } from '@candu-ai/content/create';
import { SnapshotState } from 'dashboard/pages/Content/pages/Create/pages/Snapshot';

interface Props {
  onComplete: () => void;
  onSkip?: () => void;
  setCurrentState: (state: SnapshotState) => void;
}

export const TakeSnapshot = ({ setCurrentState, onSkip, onComplete }: Props) => {
  const onGoBack = () => {
    setCurrentState('Location');
  };

  return <SnapshotContent onGoBack={onGoBack} onClick={onComplete} onSkip={onSkip} />;
};
